// Frame geometry shared by the 16:9 Slide Designer and the PPTX exporter.
// A frame is { x, y, w, h } in percent of the slide's CONTENT REGION — the
// area below the section header bar. The exported slide is 13.333333333in x 7.5in
// with a 0.85in header, so the content region is 13.333333333in x 6.65in; the
// designer stage uses that exact aspect ratio, making layout map 1:1 onto
// exported slide coordinates.

export const EXPORT_SLIDE_W = 960 / 72;
export const EXPORT_SLIDE_H = 7.5;
export const EXPORT_HEADER_H = 0.85;
export const EXPORT_CONTENT_H = EXPORT_SLIDE_H - EXPORT_HEADER_H;

const clamp = (value, min, max) => Math.min(max, Math.max(min, value));

// Cascade layout for blocks that have never been positioned
export const frameForIndex = (index = 0) => ({
    x: 6 + (index % 3) * 4,
    y: 5 + (index % 4) * 14,
    w: 46,
    h: 28
});

// Text scale bounds. `s` is a font multiplier applied to a block's text so
// the box can grow/shrink the text PowerPoint-style; only stored when it
// actually differs from 1 so untouched frames stay clean.
export const MIN_TEXT_SCALE = 0.3;
export const MAX_TEXT_SCALE = 4;

export const normalizeFrame = (frame, fallbackIndex = 0) => {
    const base = frame && typeof frame === 'object' ? frame : frameForIndex(fallbackIndex);
    const w = clamp(Number(base.w) || 46, 4, 100);
    const h = clamp(Number(base.h) || 28, 4, 100);
    const normalized = {
        x: clamp(Number(base.x) || 0, 0, 100 - Math.min(w, 8)),
        y: clamp(Number(base.y) || 0, 0, 100 - Math.min(h, 6)),
        w,
        h
    };
    const s = Number(base.s);
    if (Number.isFinite(s) && Math.abs(s - 1) > 0.001) {
        normalized.s = clamp(s, MIN_TEXT_SCALE, MAX_TEXT_SCALE);
    }
    return normalized;
};
